import templateUrl from './edit-rotation-policy.component.html';

/**
 * A component used to edit the policies that describe how payroll rotations
 * are defined and perpetuated.
 */
export const EditRotationPolicyComponent = {
    templateUrl,
    controller: function () {
        const vm = this;
        // If true, the rotation policy has no concrete set of rotations.
        vm.isAbstract;
        // If true, provide options for "Default" which represent a fallback option.
        vm.isOverride;
        vm.onChange = function () {
            if (vm.rotationPolicyForm) {
                vm.rotationPolicyForm.$setDirty(true);
            }
        };
        vm.rotationPolicy;
        vm.rotationPolicyForm;
        vm.rotationLengthTypes;
    },
    controllerAs: "vm",
    require: {
        rotationPolicyForm: "?^^form"
    },
    bindings: {
        rotationPolicy: "<",
        rotationLengthTypes: "<",
        isAbstract: "<?",
        isOverride: "<?"
    }
};
